module.exports = __webpack_public_path__ + "assets/img/32-m.87433c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/32-m.jpg
// module id = zqXa
// module chunks = 0